<app-header></app-header>

<div class="min-h-screen flex items-center short:items-start justify-center px-4 sm:px-6 md:px-8 short:pt-24 short:pb-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employer-login.png)' }">

    <div class="bg-white p-4 sm:p-6 md:p-8 short:py-3 rounded-lg shadow-md w-full max-w-2xl">
        <div class="flex justify-start mb-4 sm:mb-6 short:mb-2 pb-2 short:pb-1 border-b-[1px]">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14 short:h-10" />
        </div>

        <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-2">
            {{ 'EMPLOYER.CHANGE_PASSWORD.TITLE' | translate }}
        </h2>
        <p class="text-center text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 short:mb-2">
            {{ 'EMPLOYER.CHANGE_PASSWORD.DESCRIPTION' | translate }}
        </p>

        <div class="flex justify-center" *ngIf="!showSuccessScreen">
            <div class="w-full max-w-md px-2 sm:px-0">
                <!-- New Password Field -->
                <div class="mb-3 sm:mb-4 short:mb-2">
                    <label class="block text-xs sm:text-sm text-gray-400 mb-2 short:mb-1">{{ 'EMPLOYER.CHANGE_PASSWORD.NEW_PASSWORD_LABEL' |
                        translate }}</label>
                    <app-password-input
                        [(ngModel)]="newPassword"
                        [placeholder]="'EMPLOYER.CHANGE_PASSWORD.NEW_PASSWORD_LABEL' | translate"
                        [tabindex]="1"
                        (input)="validateNewPassword()"
                        (blur)="newPasswordTouched = true">
                    </app-password-input>
                    <div *ngIf="newPasswordTouched">
                        <div *ngFor="let error of newPasswordErrors" class="text-xs mt-1"
                            [ngClass]="{ 'text-yellow-500': error.includes('required'), 'text-red-500': !error.includes('required') }">
                            {{ error | translate }}
                        </div>
                    </div>
                    <div *ngIf="newPassword" class="mt-1 sm:mt-2">
                        <div class="flex mt-1 h-1 sm:h-1.5 bg-gray-200 rounded overflow-hidden">
                            <div class="h-full" [ngStyle]="{
                                    'width': passwordStrength === 'weak' ? '33%' : passwordStrength === 'medium' ? '66%' : '100%',
                                    'background-color': passwordStrength === 'weak' ? '#EF4444' : passwordStrength === 'medium' ? '#F59E0B' : '#10B981'
                                }">
                            </div>
                        </div>
                        <p class="text-xs sm:text-sm mt-1" [ngClass]="{
                            'text-red-500': passwordStrength === 'weak',
                            'text-yellow-500': passwordStrength === 'medium',
                            'text-green-500': passwordStrength === 'strong'
                        }">
                            {{ passwordStrengthText }}
                        </p>
                    </div>
                </div>

                <!-- Confirm New Password Field -->
                <div class="mb-4 sm:mb-6 short:mb-3">
                    <label class="block text-xs sm:text-sm text-gray-400 mb-2 short:mb-1">{{ 'EMPLOYER.CHANGE_PASSWORD.CONFIRM_PASSWORD_LABEL'
                        | translate }}</label>
                    <app-password-input
                        [(ngModel)]="confirmPassword"
                        [placeholder]="'EMPLOYER.CHANGE_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate"
                        [tabindex]="2"
                        (input)="validateConfirmPassword()"
                        (blur)="confirmPasswordTouched = true"
                        (keydown.enter)="isFormValid() && changePassword()">
                    </app-password-input>
                    <div *ngIf="confirmPasswordTouched">
                        <div *ngFor="let error of confirmPasswordErrors" class="text-xs mt-1"
                            [ngClass]="{ 'text-yellow-500': error.includes('required'), 'text-red-500': !error.includes('required') }">
                            {{ error | translate }}
                        </div>
                    </div>
                </div>

                <!-- General Error Message -->
                <div *ngIf="errorMessage" class="mb-4 text-xs sm:text-sm text-red-600">
                    {{ errorMessage }}
                </div>

                <button (click)="changePassword()" [disabled]="!isFormValid() || loading"
                    class="w-full rounded-3xl bg-white border-4 border-red-500 text-red-500 py-3 text-base sm:text-lg font-medium min-h-[48px]"
                    [ngClass]="{ 'opacity-50 cursor-default': !isFormValid() || loading, 'active:bg-red-500 active:text-white': isFormValid() && !loading }">
                    <span *ngIf="!loading">{{ 'EMPLOYER.CHANGE_PASSWORD.CHANGE_BUTTON' | translate | uppercase }}</span>
                    <span *ngIf="loading">PLEASE WAIT...</span>
                </button>

                <div class="text-center mt-4 sm:mt-6 short:mt-2">
                    <a routerLink="/employer/account/login" class="text-sm sm:text-base text-red-500 hover:underline min-h-[44px] inline-flex items-center">
                        {{ 'EMPLOYER.CHANGE_PASSWORD.BACK_TO_LOGIN' | translate }}
                    </a>
                </div>
            </div>
        </div>

        <!-- Success Screen -->
        <div *ngIf="showSuccessScreen" class="my-6 sm:my-8 text-center px-2">
            <div class="flex justify-center">
                <svg class="w-12 h-12 sm:w-16 sm:h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
            </div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mt-4">Password Changed Successfully</h2>
            <p class="text-sm sm:text-base text-gray-500 mt-4">
                You will be redirected to the login page shortly.
            </p>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>
